module.exports = __webpack_public_path__ + "img/Scarpa_BASSA_GRIGIO_SX.bff54a3c.png";